import { render, staticRenderFns } from "./InlineCard.vue?vue&type=template&id=71bacb56&"
import script from "./InlineCard.vue?vue&type=script&lang=js&"
export * from "./InlineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports